import { KeyValueModel } from "model/api";
import { EnumTipoAdiantamento } from "model/enums/enum-tipo-adiantamento";

export const TipoAdiantamentoMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoAdiantamento.SemAdiantamento, "Sem Adiantamento"),
    new KeyValueModel(EnumTipoAdiantamento.AdiantamentoSemDesconto, "Adiantamento Sem Desconto"),
    new KeyValueModel(EnumTipoAdiantamento.AdiantamentoComDesconto, "Adiantamento Com Desconto"),
];